import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import bus from '../../plugins/bus';

export default Vue.extend({
  name: 'Hero',
  data() {
    return {
      sihh: false,
      press: false,
    };
  },

  methods: {
    openVideoModal: () => {
      bus.$emit('openModal', 'VideoModal');
    },
    onArrowClick() {
      VueScrollTo.scrollTo('.innovations');
    },
  },

  mounted() {
    const url = window.location.href;

    if (url.indexOf('sihh') !== -1) {
      this.sihh = true;
    }

    if (url.indexOf('embargo') !== -1) {
      this.press = true;
    }

    bus.$on('arrow-clicked', this.onArrowClick);
  },
});



// WEBPACK FOOTER //
// ./src/js/components/hero/index.js